import { render, staticRenderFns } from "./AbaEnderecoUsuarioExterno.vue?vue&type=template&id=a321d240&"
import script from "./AbaEnderecoUsuarioExterno.vue?vue&type=script&lang=js&"
export * from "./AbaEnderecoUsuarioExterno.vue?vue&type=script&lang=js&"
import style0 from "./AbaEnderecoUsuarioExterno.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports